import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { Button, HomeLayout, Input } from '../../components'

import EnterKey from './EnterKey'
import UploadFile from './UploadFile'

import './RestoreAccount.scss'
import { isDesktop } from '../../utils'
import clsx from 'clsx'
import { login } from '../../store/user'

const RestoreAccount = () => {
   const history = useHistory()
   const dispatch = useDispatch()
   const { isAuthenticated } = useSelector(state => state.user)
   const { isDarkTheme } = useSelector(state => state.theme)

   React.useEffect(() => {
      if (isAuthenticated) {
         history.push('/home')
      }
   }, [isAuthenticated, history])

   const [mode, setMode] = React.useState('type')
   const [password, setPassword] = React.useState('')
   const [key, setKey] = React.useState('')

   const pasteFromClipboard = async () => {
      try {
         let clipboardData = await navigator.clipboard.readText()
         setKey(clipboardData)
      } catch (err) {
         console.log('Failed to copy: ', err.message)
      }
   }

   const handleSubmit = async e => {
      try {
         e.preventDefault()
         let response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/auth/restoreAccount`,
            {
               downloadKey: key,
               password: password,
            }
         )

         if (response.status === 200) {
            dispatch(
               login({
                  privateKey: response.data.privateKey,
                  publicKey: response.data.publicKey,
                  privateKeyEncrypted: key,
               })
            )
            history.push('/home')
         } else {
            console.log('Failed to restore: ', response.data.message)
         }
      } catch (err) {
         console.log('Failed to restore: ', err.message)
      }
   }

   if (isDesktop()) {
      return (
         <HomeLayout>
            <div
               className={clsx(
                  'DesktopRestoreAccount',
                  isDarkTheme && 'DesktopRestoreAccount--dark'
               )}
            >
               <div className="DesktopRestoreAccount__card">
                  <h2 className="DesktopRestoreAccount__heading">
                     Restore Account
                  </h2>
                  <p className="DesktopRestoreAccount__paragraph">
                     You will be able to restore your wallet by using a key file
                     and password if you are a WSNS user.
                  </p>
                  <div className="DesktopRestoreAccount__switch-container">
                     <Button
                        variant="ghost"
                        color="primary"
                        onClick={() =>
                           setMode(prevMode =>
                              prevMode === 'type' ? 'upload' : 'type'
                           )
                        }
                        isDarkTheme={isDarkTheme}
                     >
                        {mode === 'type' ? 'Upload File' : 'Enter Key'}
                     </Button>
                  </div>
                  <form
                     className="DesktopRestoreAccount__form"
                     onSubmit={handleSubmit}
                  >
                     <div className="DesktopRestoreAccount__mode-container">
                        {mode === 'type' ? (
                           <EnterKey
                              value={key}
                              onChange={e => setKey(e.target.value)}
                              isDarkTheme={isDarkTheme}
                              onPaste={pasteFromClipboard}
                           />
                        ) : (
                           <UploadFile  setKey={setKey} />
                        )}
                     </div>
                     <Input
                        className="DesktopRestoreAccount__form-input"
                        placeholder="Enter Password"
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        isDarkTheme={isDarkTheme}
                     />
                     <Button
                        className="DesktopRestoreAccount__form-cta"
                        variant="solid"
                        color="primary"
                        type="submit"
                        isDarkTheme={isDarkTheme}
                        size="lg"
                     >
                        Restore
                     </Button>
                  </form>
               </div>
            </div>
         </HomeLayout>
      )
   }

   return (
      <HomeLayout>
         <main
            className={clsx(
               'RestoreAccount',
               isDarkTheme && 'RestoreAccount--dark'
            )}
         >
            <h2 className="RestoreAccount__heading">Restore Account</h2>
            <p className="RestoreAccount__paragraph">
               You will be able to restore your wallet by using a key file and
               password if you are a WSNS user.
            </p>
            <div className="RestoreAccount__switch-container">
               <Button
                  variant="outline"
                  color="primary"
                  onClick={() =>
                     setMode(prevMode =>
                        prevMode === 'type' ? 'upload' : 'type'
                     )
                  }
                  isDarkTheme={isDarkTheme}
               >
                  {mode === 'type' ? 'Upload File' : 'Enter Key'}
               </Button>
            </div>
            <form className="RestoreAccount__form" onSubmit={handleSubmit}>
               <div className="RestoreAccount__mode-container">
                  {mode === 'type' ? (
                     <EnterKey onChange={setKey} isDarkTheme={isDarkTheme} />
                  ) : (
                     <UploadFile setKey={setKey} />
                  )}
               </div>
               <Input
                  className="RestoreAccount__form-input"
                  placeholder="Enter Password"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  isDarkTheme={isDarkTheme}
               />
               <Button
                  className="RestoreAccount__form-cta"
                  variant="solid"
                  color="primary"
                  type="submit"
                  onClick={handleSubmit}
                  isDarkTheme={isDarkTheme}
               >
                  Restore
               </Button>
            </form>
         </main>
      </HomeLayout>
   )
}

export default RestoreAccount
